import React from "react";
import { RouterComponent } from "./routes";
import { Provider } from "react-redux";
import { store } from "./store";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <RouterComponent />
      </Provider>
    </div>
  );
}

export default App;
